
import {
  apiAiModelList,
  apiAiModelAdd,
  apiAiModelEdit,
  apiAiModelDetail,
  apiAiModelDel,
  apiAiTypeList,
  apiAiCateList,
} from "@/api/setting";
import { Component, Prop, Vue } from "vue-property-decorator";
import LsPagination from "@/components/ls-pagination.vue";
import { RequestPaging } from "@/utils/util";
import LsDialog from "@/components/ls-dialog.vue";
import LsForm from "@/components/ls-form.vue";
import MaterialSelect from "@/components/material-select/index.vue";
import PromotCommon from "@/components/promot-common.vue";
import cloneDeep from "lodash/cloneDeep";
import { values } from "lodash";

@Component({
  components: {
    LsDialog,
    LsPagination,
    LsForm,
    MaterialSelect,
    PromotCommon,
  },
})
export default class AiActionList extends Vue {
  // 分页
  pager: RequestPaging = new RequestPaging();
  apiAiModelList = apiAiModelList;
  searchObj: any = {
    name: "",
  };
  mode = "add";
  dataForm: any = {
    name: "",
    ai_type: "",
    ai_url: "",
    ai_job_url: "",
    ai_model: "",
    ai_system: "",
    category: "",
    ai_money: "",
    option: "",
    status: 1,
    sort: 0,
    other: "",
  };
  model_id = null;
  orignimg = "";
  resultimg = "";
  aiCateOptions: any = [];
  formVisible = false;
  aiTypeOptions: any = [];
  paramsForm: any = [];
  paramsTypeOptions: any = [
    {
      label: "输入框",
      value: "text",
    },
    {
      label: "数字输入框",
      value: "number",
    },
    {
      label: "文本框",
      value: "textarea",
    },
    {
      label: "图片",
      value: "image",
    },
    {
      label: "图片(单)",
      value: "image_1",
    },
    {
      label: "图片(多图)",
      value: "images",
    },
    {
      label: "下拉选择",
      value: "select",
    },
    {
      label: "按钮组",
      value: "btngroup",
    },
    {
      label: "单选",
      value: "radio",
    },
    {
      label: "滑块",
      value: "slider",
    },
    {
      label: "类型块",
      value: "imgstyle",
    },
    {
      label: "提示词",
      value: "prompt",
    },
    {
      label: "标签",
      value: "tab",
    },
  ];
  // 获取列表
  getList() {
    this.pager.request({
      callback: apiAiModelList,
      params: this.searchObj,
    });
  }

  handleSortChange(row: any) {
    let values = {
      id: row.id,
      name: row.name,
      ai_type: row.ai_type,
      ai_url: row.ai_url,
      ai_job_url: row.ai_job_url,
      ai_model: row.ai_model,
      ai_system: row.ai_system,
      category: row.category,
      ai_money: row.ai_money,
      option: row.option,
      status: row.status,
      sort: row.sort,
      other: row.other,
    };
    apiAiModelEdit(values).then((res: any) => {
      this.getList();
      this.formVisible = false;
    });
  }

  handleStatusChange(row: any) {
    let values = {
      id: row.id,
      name: row.name,
      ai_type: row.ai_type,
      ai_url: row.ai_url,
      ai_job_url: row.ai_job_url,
      ai_model: row.ai_model,
      ai_system: row.ai_system,
      category: row.category,
      ai_money: row.ai_money,
      option: row.option,
      status: row.status == 1 ? 0 : 1,
      sort: row.sort,
      other: row.other,
    };
    apiAiModelEdit(values).then((res: any) => {
      this.getList();
      this.formVisible = false;
    });
  }

  handleAdd() {
    this.dataForm = {
      name: "",
      ai_type: "",
      ai_url: "",
      ai_job_ur: "",
      ai_model: "",
      ai_system: "",
      ai_money: "",
      category: "",
      option: "",
      status: 1,
      sort: 0,
      other: "",
    };
    this.mode = "add";
    this.formVisible = true;
  }

  extractVariables(str: string) {
    const keys = (str.match(/\$\{([^}]+)\}/g) || []).map((item) =>
      item.slice(2, -1),
    );
    const options = [];
    let oldData = cloneDeep(this.paramsForm);
    for (let item of keys) {
      options.push({
        ...{ field: item },
        ...this.paramsFormOldData(item, oldData),
      });
    }
    this.paramsForm = options;
  }

  paramsFormOldData(field: string, oldData: any) {
    let params = oldData.find((item: any) => item.field == field);
    return params;
  }

  async handleEdit(row: any) {
    let res = await apiAiModelDetail({ id: row.id });

    this.dataForm = {
      id: res.id,
      name: res.name,
      ai_type: res.ai_type,
      ai_url: res.ai_url,
      ai_job_url: res.ai_job_url,
      ai_model: res.ai_model,
      ai_system: res.ai_system,
      ai_money: res.ai_money,
      category: res.category,
      option: res.option,
      status: res.status,
      sort: res.sort,
      other: res.other,
    };
    if (res.option) {
      this.paramsForm = JSON.parse(res.option);
    }
    if (res.other) {
      let other = JSON.parse(res.other);
      this.orignimg = other.orignimg;
      this.resultimg = other.resultimg;
    } else {
      this.orignimg = "";
      this.resultimg = "";
    }
    this.mode = "edit";
    this.formVisible = true;
  }

  handleSubmit() {
    let value = this.dataForm;
    value.option = JSON.stringify(this.paramsForm);
    value.other = JSON.stringify({
      orignimg: this.orignimg,
      resultimg: this.resultimg,
    });
    if (this.mode == "add") {
      apiAiModelAdd(value).then((res: any) => {
        this.getList();
        this.formVisible = false;
      });
    } else {
      apiAiModelEdit(value).then((res: any) => {
        this.getList();
        this.formVisible = false;
      });
    }
  }

  handleDelete(id: number) {
    apiAiModelDel({ id: id }).then((res: any) => {
      this.getList();
    });
  }

  gettypeList() {
    apiAiTypeList({}).then((res) => {
      this.aiTypeOptions = res.map((item: any) => ({
        label: item.name,
        value: item.type,
      }));
    });
  }

  getCateList() {
    apiAiCateList({}).then((res) => {
      this.aiCateOptions = res.map((item: any) => ({
        label: item.name,
        value: item.type,
      }));
    });
  }

  created() {
    this.gettypeList();
    this.getCateList();
    this.getList();
  }
}
